import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PublicationAccessService
} from "../../../../app/modules/landing-publication/publication-access.service";
import {ExtProfilesService} from "../../../../app/modules/landing-publication/ext-profiles/ext-profiles.service";
import {SurveyViewerService} from "../../../../app/modules/survey/survey-viewer/services/survey-viewer.service";
import {ExtProfileDirective} from "../../../../app/modules/landing-publication/ext-profiles/types/extProfile.directive";
// import {PublicationAccessModule} from "../../../../app/modules/landing-publication/publication-access.module";

@Component({
  selector: 'app-test-survey-ext',
  standalone: true,
  imports: [CommonModule, ExtProfileDirective],
  templateUrl: './test-survey-ext.component.html',
  styleUrls: ['./test-survey-ext.component.scss']
})
export class TestSurveyExtComponent implements OnInit {

  constructor(
    public extProfilesService: ExtProfilesService,
    public publicationAccessService: PublicationAccessService,
    public surveyViewerService: SurveyViewerService,
  ) {
    // const pub: IPublication = this.publicationAccessService.publication$.value;
    // const extNeeded = pub.extProfilsNeeded;
  }

  ngOnInit(): void {

    // console.log(this.surveyViewerService.activeSurvey$.value);

  }

}
